// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArrowRightLineSvg from '@rsuite/icon-font/lib/direction/ArrowRightLine';
var ArrowRightLine = createSvgIcon({
    as: ArrowRightLineSvg,
    ariaLabel: 'arrow right line',
    category: 'direction',
    displayName: 'ArrowRightLine'
});
export default ArrowRightLine;
